import { CSSProperties, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Column } from 'react-table';
import styled from 'styled-components';
import { Text } from 'shared/Typhography';

import { Button, TableComponent } from '../../../../../shared/Components';
import { ActionButtons } from '../../../../../shared/Components/Table/Table';
import { strings } from '../../../../../strings';
import { Roles } from '../../../../../shared/enums';
import { capitalize } from '../../../../../utilities';
import { MODAL_TYPES, useGlobalModalContext } from '../../../../../context/GlobalModal';
import DeleteColoringGridCollectionButton from '../../CreateCollectionScreen/DeleteColoringGridCollectionButton';

const RoleCell = styled.span`
  padding-left: 4px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
`;

const TextCell = styled(Text)<Pick<CSSProperties, 'width'>>`
  cursor: pointer;
  padding-left: 4px;
  width: ${({ width }) => width};
`;

interface Data {
  firebaseId: string;
  name: string;
  numberOfColoringGrids: number;
  isAdminOnly: boolean;
  action: () => void;
}

interface CollectionTableProps {
  data: any;
}

export const ColoringGridCollectionTable = ({ data }: CollectionTableProps) => {
  const { showModal } = useGlobalModalContext();
  const history = useHistory();

  const openEditModal = (collection: any) => {
    showModal(MODAL_TYPES.EDIT_COLORING_GRID_COLLECTION_MODAL, {
      title: strings.modals.editColoringGridCategory.title,
      collection: collection,
    });
  };
  const headers: Column<Data>[] = useMemo(
    () => [
      {
        Header: strings.collectionTableHeaderName,
        accessor: 'name',
        Cell: (cell) => (
          <TextCell
            width={`${(window.screen.width * 22) / 100}px`}
            ellipsisOnRow={1}
            onClick={() => history.push(`/coloring-grids?category=${cell.row.original.firebaseId}`)}
          >
            {cell.row.original.name}
          </TextCell>
        ),
        width: '45%',
      },
      {
        Header: strings.collectionTableHeaderType,
        accessor: 'isAdminOnly',
        Cell: (cell) => {
          const role = cell.row.original.isAdminOnly ? Roles.Admin : Roles.None;

          return <RoleCell>{capitalize(role)}</RoleCell>;
        },
        width: '15%',
        sortType: (rowA) => (rowA.original.isAdminOnly ? 1 : -1),
      },
      {
        Header: strings.collectionTableHeaderNumberOfColoringGrid,
        accessor: 'numberOfColoringGrids',
        width: '20%',
        Cell: (cell) => (
          <span
            onClick={() => history.push(`/coloring-grids?category=${cell.row.original.firebaseId}`)}
            style={{ cursor: 'pointer' }}
          >
            {cell.row.original.numberOfColoringGrids}
          </span>
        ),
      },
      {
        Header: strings.collectionTableHeaderAction,
        accessor: 'action',
        Cell: (cell) => (
          <ActionButtons>
            <Button
              variant="secondary"
              onClick={() => openEditModal(cell.row.original)}
              width={100}
              height={30}
            >
              Edit
            </Button>

            <DeleteColoringGridCollectionButton
              name={cell.row.original.name}
              collectionId={cell.row.original.firebaseId}
            />
          </ActionButtons>
        ),
      },
    ],
    [],
  );

  return <TableComponent columns={headers} data={data} />;
};
